import data from "../../.sourceflow/homepage_tiles.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const homepage_tiles_helper = new CollectionHelper(data);
